export default __webpack_public_path__ + "static/media/mobile_fury.d1209276.webp";